import { useRef, useState, useEffect } from "react";
import { webUrlNode } from "../../../../constants/appInfo";
import ComposeMessageCard from "./ComposeMessageCard";

export default function StepNode({
  step,selected,
  onPositionChange,
  onPositionCommit,buttons,
  onSelect,onStartLink,
  onHoverTarget, linkingFrom,mousePos,hoverStepId,
  setLinkingFrom,  // step
setMousePos ,     // {x,y}
 setHoverStepId ,reloadLinks,stepTemplate,setStepTemplate,actionKey
}) {

  const ref = useRef(null);

  const dragRef = useRef({
    dragging: false,
    offsetX: 0,
    offsetY: 0,
    moved: false
  });

  const [, force] = useState(0); // only to re-render cursor

  function onMouseDown(e) {

    e.stopPropagation();

    const rect = ref.current.getBoundingClientRect();

    dragRef.current.dragging = true;
    dragRef.current.moved = false;

    dragRef.current.offsetX = e.clientX - rect.left;
    dragRef.current.offsetY = e.clientY - rect.top;

    window.addEventListener("mousemove", onWindowMove);
    window.addEventListener("mouseup", onWindowUp);

    force(v => v + 1);
  }

  function onWindowMove(e) {

    if (!dragRef.current.dragging) return;

    dragRef.current.moved = true;

    const parent =
      ref.current.parentElement.getBoundingClientRect();

    const x =
      e.clientX - parent.left - dragRef.current.offsetX;

    const y =
      e.clientY - parent.top - dragRef.current.offsetY;

    onPositionChange(step.id, x, y);
  }

  function onWindowUp() {

    if (!dragRef.current.dragging) return;

    dragRef.current.dragging = false;

    window.removeEventListener("mousemove", onWindowMove);
    window.removeEventListener("mouseup", onWindowUp);

    // commit only if user really dragged
    if (dragRef.current.moved) {
      onPositionCommit?.(step.id, step.x, step.y);
    }

    force(v => v + 1);
  }

  useEffect(() => { 
    return () => {
      window.removeEventListener("mousemove", onWindowMove);
      window.removeEventListener("mouseup", onWindowUp);
    };
  }, []);

 function handleClick() {

  // if we are in linking mode, this node is the target
  if (linkingFrom && linkingFrom.id !== step.id) {
    createLink(linkingFrom.id, step.id);
    setLinkingFrom(null);
    setMousePos(null);
    return;
  }

  onSelect?.(step);
}
function startLink(e, actionKey) {

  const rect = e.currentTarget.getBoundingClientRect();

  onStartLink({
    step,
    actionKey,
    x: rect.right-100 ,
    y: rect.top-23 
  });
}
async function createLink(fromId, toId) {

  const createNewLink=await fetch(`${webUrlNode}/api/funnels/steps/link`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({appId:35,
      fromStepId: fromId,
      toStepId: toId,
     actionType: "BUTTON",
    actionKey: actionKey,
    delaySeconds:300
    })
  })



  reloadLinks();
}
const border =
  hoverStepId === step.id
    ? "2px solid #2563eb"
    : selected
      ? "2px solid blue"
      : "1px solid #ccc";
  return (<>
    <div
      ref={ref}
      onMouseDown={onMouseDown}
      onClick={handleClick}
    onMouseEnter={() => linkingFrom && onHoverTarget?.(true)}
onMouseLeave={() => linkingFrom && onHoverTarget?.(false)}
      style={{
        position: "absolute",
        left: step.x,
        top: step.y,
        
        padding: 10,
         border: border,

        background: "#fff",
        borderRadius: 6,
        cursor: dragRef.current.dragging ? "grabbing" : "grab",
        userSelect: "none",
        boxShadow: dragRef.current.dragging
          ? "0 6px 14px rgba(0,0,0,0.15)"
          : "none"
      }}
    >
      <div style={{ fontWeight: 600 }}>
        {step.title || step.useCase}
      </div>

      {step.isStart === "true" && (
        <div style={{ fontSize: 11, color: "green" }}>
          START
        </div>
      )}
      
 
    </div>
    
    {selected && stepTemplate && (<div
    style={{
        position: "absolute",zIndex:99999999999,
        left: step.x+80,
        top: step.y,
        
        padding: 10,
         border: border,
        

        background: "#fff",
        borderRadius: 6,
        cursor: dragRef.current.dragging ? "grabbing" : "grab",
        userSelect: "none",
        boxShadow: dragRef.current.dragging
          ? "0 6px 14px rgba(0,0,0,0.15)"
          : "none"
      }}>
  {(() => {
  let buttons = [];
  try {
    buttons = JSON.parse(stepTemplate?.actionsJson || "[]");
  } catch {}
  return selected && buttons?.map((b,i) => (
  <div
    key={b.id}
    onMouseDown={e => {
      e.stopPropagation();
      startLink(e, actionKey);  // << very important
    }}
    style={{
      fontSize: 12,
      width:"15px",height:"15px",borderRadius:"50%",
      marginTop: 4,right:"0px",
      position:"absolute",top:10+10*i+10*i,
      
      cursor: "crosshair",
      background: "#3379be"
    }}
  >
    
  </div>
));
})()
}
  <ComposeMessageCard
    message={{
      type: "email",
      subject: stepTemplate.subjectTemplate,
      body: stepTemplate.htmlTemplate,
      buttons: (() => {
        try {
          return JSON.parse(stepTemplate.actionsJson || "[]");
        } catch {
          return [];
        }
      })()
    }}
    onChange={(msg) => {

      // for now: just keep it in memory
      // (next step you can save overrides per step)

      setStepTemplate(prev => ({
        ...prev,
        subjectTemplate: msg.subject,
        htmlTemplate: msg.body,
        actionsJson: JSON.stringify(msg.buttons || [])
      }));

    }}
  /></div>

)}</>
  );
}
